import React from "react";
type LogProps = React.PropsWithChildren<{}>;
function Log(props: LogProps) {
	return <div className="h-full">{props.children}</div>;
}

export default Log;
